// extracted by mini-css-extract-plugin
module.exports = {"richText":"TinyMCERichText_richText__JWYCI","bold":"TinyMCERichText_bold__SJ5zf"};